export const filterCategory = (categoryId, isActive) => ({
	categoryId: categoryId,
	isActive: isActive,

  init() {
    window.addEventListener('filterCategoryToggled', (event) => {
      if (event.detail.categoryId === this.categoryId) {
        this.isActive = !this.isActive
      } else {
        this.isActive = false
      }
    })
  },

  toggleActive() {
    if (this.isActive) {
      this.isActive = false
    } else {
      window.dispatchEvent(new CustomEvent('filterCategoryToggled', {
        detail: {
          categoryId: this.categoryId,
        }
      }))
    }
  },

	updateMatchingSprigSelect() {
		const sprigSelect = document.querySelector(this.$root.getAttribute('data-select-to-sync'))
		if (sprigSelect === null) return

		const matchingSprigOption = sprigSelect.querySelector('option[value="' + this.categoryId + '"]')    

		if (matchingSprigOption.disabled) {
			sprigSelect.value = ''

			const sprigChangeEvent = new Event('change')
			sprigSelect.dispatchEvent(sprigChangeEvent)

			return
		}

    if (this.isActive) {
      sprigSelect.value = ''
    } else {
      sprigSelect.value = this.categoryId
    }

		setTimeout(() => {
      const sprigChangeEvent = new Event('change')
		  sprigSelect.dispatchEvent(sprigChangeEvent)

      this.toggleActive()
    }, 250) 
	}
})
